<template>
  <div class="">
    <div class="calendar-inline">
      <div v-if="production !== null" class="calendar-inline__calendar">
        <flat-pickr v-model="dataTime" :config="config" name="date" style="display: none;"></flat-pickr>
      </div>
      <div class="calendar-inline__block">
        <div class="calendar-inline__block_item">
          <div class="calendar-inline__form">
            <div class="calendar-inline__form_title">Диапазон дат</div>
            <div class="calendar-inline__form_select">
              <select v-model="firstSelect" @change="firstSelectChange" name="" id="q0">
                <option value="null" disabled selected>Выбрать</option>
                <option value="0">10 дней</option>
                <option value="1">Месяц</option>
                <option value="2">Выбрать вручную</option>
              </select>
            </div>
            <div class="calendar-inline__form_input">
              <!-- disabled добавляет перечеркнутый крук, readonly курсор стрелка (disabled указан с высшим приоритетом над readonly)-->
              <input :disabled="firstDate.locked" type="text" :value="firstDate.from | date">
              <input :disabled="firstDate.locked" type="text" :value="firstDate.to | date">
            </div>
            <!--              <div class="calendar-inline__form_check">-->
            <!--                <span @click="toggleCompare" :class="[compare ? 'checked' : '']">Сравнить с</span>-->
            <!--              </div>-->
            <div v-show="compare" class="calendar-inline__form_select">
              <select v-model="secondSelect" @change="secondSelectChange" name="" id="q1">
                <option value="null" disabled selected>Выбрать</option>
                <option value="0">10 дней</option>
                <option value="1">Месяц</option>
                <option value="2">Выбрать вручную</option>
              </select>
            </div>
            <div v-show="compare" class="calendar-inline__form_input">
              <input :disabled="secondDate.locked" type="text" :value="secondDate.from | date">
              <input :disabled="secondDate.locked" type="text" :value="secondDate.to | date">
            </div>
            <div class="calendar-inline__form_buttons">
              <span @click="clear" class="cancel">отмена</span>
              <span @click="fetch" class="submit">применить</span>
              <div class="download_btn">
                <button @click="downloadProduction">Download</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
// import 'flatpickr/dist/flatpickr.css'
import moment from 'moment'
import data from '@/api/data'

export default {
  name: 'ProductionCalendar',
  components: {
    flatPickr
  },
  data() {
    const _this = this

    return {
      dataTime: '',
      firstSelect: 2,
      secondSelect: null,
      compare: false,
      selectingFirstDate: true,
      firstDate: {
        from: moment().subtract(10, 'days'),
        to: moment(),
        locked: false
      },
      secondDate: {
        from: null,
        to: null,
        locked: true
      },
      config: {
        dateFormat: 'Y-m-d H:i',
        mode: 'range',
        inline: true,
        showMonths: 2,
        monthSelectorType: 'static',
        locale: {
          firstDayOfWeek: 1
        },
        onDayCreate: (dObj, dStr, fp, dayElem) => {
          const date = moment(dayElem.dateObj)
          if (_this.compare) {
            let range
            if (_this.selectingFirstDate) {
              range = _this.secondDate
            } else {
              range = _this.firstDate
            }

            if (date.isBetween(range.from, range.to, undefined, '[]')) {
              dayElem.classList.add('highlight')
            }
          }

          if (_this.production.has(date.format('YYYY-MM-DD'))) {
            dayElem.innerHTML += `<span class='calendar-number'>${_this.production.get(date.format('YYYY-MM-DD'))}</span>`
          } else {
            dayElem.innerHTML += `<span class='calendar-number'>-</span>`
          }
        },
        onChange(selectedDates) {
          console.log('Im here!')
          if (_this.selectingFirstDate && !_this.firstDate.locked) {
            _this.firstDate.from = moment(selectedDates[0])
            _this.firstDate.to = moment(selectedDates[1])
          } else if (!_this.secondDate.locked) {
            _this.secondDate.from = moment(selectedDates[0])
            _this.secondDate.to = moment(selectedDates[1])
          }
        }
      }
    }
  },
  filters: {
    date(value) {
      if (value === null) {
        return null
      } else {
        return value.format('DD MMM YYYY')
      }
    }
  },
  computed: {
    production() {
      return this.$store.getters['production/productionMap']
    }
  },
  methods: {
    clear() {
      this.dataTime = ''
    },
    downloadProduction() {
      data.productionAndInsolationByHour(this.$route.params.id, {
        from: this.firstDate.from,
        to: this.firstDate.to
      }).then(r => {
        const rows = [
          ['Time', 'Production, kWh', 'Wh/m^2'],
        ];

        r.data.forEach(val => {
          rows.push([
            moment(val.time).format('YYYY-MM-DD HH:mm:ss'),
            String(val.production).replace('.', ','),
            String(val.insolation).replace('.', ','),
          ]);
        });

        let csvContent = "data:text/csv;charset=utf-8,"
          + rows.map(e => e.join(';')).join("\n");


        var encodedUri = encodeURI(csvContent);
        var link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", "my_data.csv");
        document.body.appendChild(link); // Required for FF
        link.click(); // This will download the data file named "my_data.csv".
        document.body.removeChild(link); // Remove created link
      })
    },
    fetch() {
      if (this.compare) {
        this.$store.commit('production/COMPARE_PRODUCTION', {
          firstDateFrom: this.firstDate.from,
          firstDateTo: this.firstDate.to,
          secondDateFrom: this.secondDate.from,
          secondDateTo: this.secondDate.to
        })
      } else {
        this.$store.commit('production/FETCH_PRODUCTION', {
          dateFrom: this.firstDate.from,
          dateTo: this.firstDate.to
        })
      }
    },
    toggleCompare() {
      this.compare = !this.compare

      if (this.compare) {
        this.setSelectingSecondDate()
      } else {
        this.setSelectingFirstDate()
      }
    },
    setSelectingFirstDate() {
      this.selectingFirstDate = true
    },
    setSelectingSecondDate() {
      this.selectingFirstDate = false
    },
    firstSelectChange() {
      if (this.firstSelect === '0') {
        this.firstDate.locked = true
        this.firstDate.from = moment().subtract(10, 'days')
        this.firstDate.to = moment()
      } else if (this.firstSelect === '1') {
        this.firstDate.locked = true
        this.firstDate.from = moment().startOf('month')
        this.firstDate.to = moment()
      } else if (this.firstSelect === '2') {
        this.firstDate.locked = false
        this.firstDate.from = null
        this.firstDate.to = null
      }
    },
    secondSelectChange() {
      if (this.secondSelect === '0') {
        this.secondDate.locked = true
        this.secondDate.from = moment().subtract(10, 'days')
        this.secondDate.to = moment()
      } else if (this.secondSelect === '1') {
        this.secondDate.locked = true
        this.secondDate.from = moment().startOf('month')
        this.secondDate.to = moment()
      } else if (this.secondSelect === '2') {
        this.secondDate.locked = false
        this.secondDate.from = null
        this.secondDate.to = null
      }
    }
  },
  mounted() {
    this.$store.dispatch('production/loadDayProduction', this.$route.params.id)
  },
  created() {
    this.fetch()
  }
}
</script>

<style>
.download_btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.download_btn button {
  display: block;
  float: left;
  margin-top: 24px;
  cursor: pointer;
  height: 44px;
  line-height: 46px;
  color: #fff;
  text-align: center;
  background: #02a8eb;
  border: 0px;
  padding: 0 11px 0 11px;
  text-decoration: none !important;
  position: relative;
  width: 240px;
  max-width: 100%;
  text-transform: uppercase;
  border-radius: 4px;
  font-weight: 700;
  box-shadow: none;
}

.download_btn button:hover {
  background: #2d8bdc;
}
</style>
